export const CHILDREN_TYPE = {
  A: '高学年',
  B: '低学年',
  C: '食事・布団付',
  D: '食事のみ',
  E: '布団のみ',
  F: '食事・布団不要'
}